import BaseModelAPI from '../BaseModelAPI';

export default class IncomingDocumentStatus extends BaseModelAPI {
	static entity = 'incomingdocumentstatus';
	static entityName = 'incomingdocumentstatus';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.name = '';
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}